// client/src/components/common/AssinaturaCanvas.js
// Captura de assinatura digital no painel web via canvas HTML5 + signature_pad
// (mesma base que react-native-signature-canvas usa no lado web). Componente
// controlado por ref: o pai chama `ref.current.getSignature()` (retorna
// base64 PNG ou null se o canvas estiver vazio) e `ref.current.clear()`.
// Reutilizado por Contratos e Anamnese — não é exclusivo de um módulo.
import React, { useEffect, useImperativeHandle, useRef, forwardRef } from 'react';
import SignaturePad from 'signature_pad';
import { Eraser } from 'lucide-react';

const AssinaturaCanvas = forwardRef(({ height = 200 }, ref) => {
    const canvasRef = useRef(null);
    const padRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const resizeCanvas = () => {
            const ratio = Math.max(window.devicePixelRatio || 1, 1);
            const rect = canvas.getBoundingClientRect();
            canvas.width = rect.width * ratio;
            canvas.height = rect.height * ratio;
            canvas.getContext('2d').scale(ratio, ratio);
            padRef.current?.clear();
        };

        padRef.current = new SignaturePad(canvas, {
            backgroundColor: 'rgb(255, 255, 255)',
            penColor: 'rgb(20, 20, 20)',
        });

        resizeCanvas();
        window.addEventListener('resize', resizeCanvas);
        return () => {
            window.removeEventListener('resize', resizeCanvas);
            padRef.current?.off();
        };
    }, []);

    useImperativeHandle(ref, () => ({
        getSignature: () => (padRef.current && !padRef.current.isEmpty() ? padRef.current.toDataURL('image/png') : null),
        clear: () => padRef.current?.clear(),
        isEmpty: () => padRef.current?.isEmpty() ?? true,
    }));

    return (
        <div>
            <div style={{ border: '1px dashed var(--color-border, #ccc)', borderRadius: '8px', overflow: 'hidden', background: '#fff' }}>
                <canvas ref={canvasRef} style={{ width: '100%', height: `${height}px`, display: 'block', touchAction: 'none' }} />
            </div>
            <div className="flex justify-between items-center mt-2">
                <span className="text-sm text-gray-500">Assine no espaço acima</span>
                <button type="button" onClick={() => padRef.current?.clear()} className="action-button action-button-secondary" style={{ padding: '4px 10px' }}>
                    <Eraser size={14} className="icon" /> Limpar
                </button>
            </div>
        </div>
    );
});

export default AssinaturaCanvas;
